import styled from "styled-components";
import { GridColDef } from "@mui/x-data-grid";
import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { useNavigate, useParams } from "react-router-dom";
import { urlOperator } from "../../../utils/url";
import { GoBackButton } from "../../../components/GoBackButton";
import { StyledButton } from "../../../components/Button/button";
import { GetOrdersDetailsPayloadResponse } from "../../../services/orders/orders-details-get-by-id/types";
import { getOrdersDetailsGetById } from "../../../services/orders/orders-details-get-by-id";
import { LoadingBackDrop } from "../../../components/loader";
import { Summary, SummaryPropertyItem } from "./components/Summary";
import { Services } from "./components/Services";
import { QuantumDetailOrder } from "./components/QuantumDetailOrder";
import { theme } from "../../../helpers/theme";
import { AdditionalInfo } from "./components/AdditionalRemarks";
import {
  dateFormating,
  getPlaceEnum,
  getPurposeFromEnum,
  getServiceFromEnum,
  getStatusFromEnum,
  getTemperatureConditionsEnum,
  getTypeFromEnum,
} from "../operator-orders-offering/helpers";
import { Divider } from "@mui/material";
export const OperatorOrdersDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [ordersDetails, setOrdersDetails] = useState<
    GetOrdersDetailsPayloadResponse[]
  >([]);
  const body = {
    id_zamowienie: id,
  };
  const GetOrdersDetails = useQuery(
    ["OrdersDetail"],
    () => getOrdersDetailsGetById(body),
    {
      refetchOnMount: true,
      refetchOnWindowFocus: false,
      onSuccess(res) {
        setOrdersDetails([res.data.payload]);
      },
    }
  );

  const detailTableInfoPart1: SummaryPropertyItem[] = [
    {
      propertyKey: "Nr zamówienia",
      propertyName: "Nr zamówienia",
      propertyValue: `${ordersDetails[0]?.numer_zamowienia}`,
    },
    {
      propertyKey: "Status",
      propertyName: "Status",
      propertyValue: `${getStatusFromEnum(
        ordersDetails[0]?.status_zamowienia
      )}`,
    },
    {
      propertyKey: "Klient",
      propertyName: "Klient",
      propertyValue: `${ordersDetails[0]?.klient.nazwa}`,
    },
    {
      propertyKey: "Kontakt",
      propertyName: "Kontakt",
      propertyValue: `${ordersDetails[0]?.klient.telefon}`,
    },

    {
      propertyKey: "Cel zamówienia",
      propertyName: "Cel zamówienia",
      propertyValue: `${getPurposeFromEnum(
        ordersDetails[0]?.uslugi_zamowione.cel_zamowienia
      )}`,
    },
    {
      propertyKey: "Miejsce",
      propertyName: "Miejsce",
      propertyValue: `${getPlaceEnum(ordersDetails[0]?.miejsce)}`,
    },
    {
      propertyKey: "Usługi dodatkowe",
      propertyName: "Usługi dodatkowe",
      propertyValue:
        ordersDetails[0]?.uslugi_zamowione.uslugi_dodatkowe.length > 0
          ? ordersDetails[0]?.uslugi_zamowione.uslugi_dodatkowe.map(
              (item, index) =>
                `${getServiceFromEnum(item)}${
                  index + 1 <
                  ordersDetails[0]?.uslugi_zamowione.uslugi_dodatkowe.length
                    ? ", "
                    : ""
                }`
            )
          : "",
    },
    {
      propertyKey: "Liczba usł. dodatkowych",
      propertyName: "Liczba usł. dodatkowych",
      propertyValue:
        ordersDetails[0]?.uslugi_zamowione.uslugi_dodatkowe.length > 0 &&
        ordersDetails[0]?.uslugi_zamowione.ilosc_dodatkowych
          ? ordersDetails[0]?.uslugi_zamowione.ilosc_dodatkowych.toString()
          : "",
    },
  ];
  const detailTableInfoPart2: SummaryPropertyItem[] = [
    {
      propertyKey: "Rodzaj towaru",
      propertyName: "Rodzaj towaru",
      propertyValue: `${getTypeFromEnum(ordersDetails[0]?.rodzaj_towaru)}`,
    },
    {
      propertyKey: "Opis towaru",
      propertyName: "Opis towaru",
      propertyValue: ordersDetails[0]?.opis_towaru
        ? `${ordersDetails[0]?.opis_towaru}`
        : "-",
    },
  ];
  const detailTableInfoPart3: SummaryPropertyItem[] = [
    {
      propertyKey: "Termin rozpoczęcia",
      propertyName: "Termin rozpoczęcia",
      propertyValue: `${dateFormating(ordersDetails[0]?.termin_rozpoczecia)}`,
    },
    {
      propertyKey: "Termin zakończenia",
      propertyName: "Termin zakończenia",
      propertyValue: `${dateFormating(ordersDetails[0]?.termin_zakonczenia)}`,
    },

    {
      propertyKey: "Warunek temp",
      propertyName: "Warunek temp",
      propertyValue: `${getTemperatureConditionsEnum(
        ordersDetails[0]?.warunek_temperaturowy
      )}`,
    },
    {
      propertyKey: "Rodzaj składowania",
      propertyName: "Rodzaj składowania",
      propertyValue: ordersDetails[0]?.skladowanie_plaskie
        ? "składowanie płaskie"
        : ordersDetails[0]?.wysokie_skladowanie
        ? "wysokie składowanie"
        : ordersDetails[0]?.polki
        ? "półki"
        : "",
    },
  ];
  const detailAdditionalInfo: SummaryPropertyItem[] = [
    {
      propertyKey: "Specjalny sprzęt",
      propertyName: "Specjalny sprzęt",
      propertyValue: ordersDetails[0]?.specjalny_sprzet
        ? `${ordersDetails[0]?.specjalny_sprzet}`
        : "-",
    },
    {
      propertyKey: "Opis usługi",
      propertyName: "Opis usługi",
      propertyValue: ordersDetails[0]?.opis_uslugi
        ? `${ordersDetails[0]?.opis_uslugi}`
        : "-",
    },
  ];
  if (GetOrdersDetails.isLoading || GetOrdersDetails.isRefetching) {
    return <LoadingBackDrop loading={true} />;
  }
  return (
    <OrderContainer>
      <ViewNavigation>
        <Redirect>
          <GoBackButton description={"Powrót"} goToUrl={urlOperator.orders} />
        </Redirect>
        <Redirect>
          <StyledButton
            onClick={() => navigate(urlOperator.clients)}
            sx={{ marginLeft: "10px", minWidth: "100px" }}
          >
            Klienci
          </StyledButton>
          <StyledButton
            onClick={() => {
              navigate(`/operator/orders/offering/${id}`);
            }}
            sx={{ marginLeft: "10px", minWidth: "100px" }}
          >
            Ofertowanie
          </StyledButton>
        </Redirect>
      </ViewNavigation>
      <WhitePage>
        <SectionTitle>Szczegóły zamówienia</SectionTitle>
        <Divider sx={{ marginBottom: "26px" }} />
        <SummaryTableContainer>
          <Summary data={detailTableInfoPart1} />
        </SummaryTableContainer>
        <SummaryTableContainer>
          <Summary data={detailTableInfoPart2} />
        </SummaryTableContainer>
        <SummaryTableContainer>
          <Summary data={detailTableInfoPart3} />
        </SummaryTableContainer>
        {/* <ServicesContainer>
          <Services
            title={"Usługi"}
            data={ordersDetails[0]?.uslugi_zamowione?.uslugi_dodane}
            descriptioData={[
              {
                propertyName: "Opis usługi",
                propertyValue: ordersDetails[0]?.opis_uslugi
                  ? `${ordersDetails[0]?.opis_uslugi}`
                  : "",
              },
            ]}
          />
        </ServicesContainer> */}
        <Summary data={detailAdditionalInfo} />
        <AdditionalInfo
          data={[
            {
              propertyKey: "Dodatkowe uwagi do całosci zamówienia",
              propertyName: "Dodatkowe uwagi",
              propertyValue: ordersDetails[0]?.dodatkowe_uwagi
                ? `${ordersDetails[0]?.dodatkowe_uwagi}`
                : "-",
            },
          ]}
        />
      </WhitePage>
      <WhitePage>
        <SectionTitle>Przedmiot składowania:</SectionTitle>
        <Divider sx={{ marginBottom: "10px" }} />
        <QuantumContainer>
          <QuantumDetailOrder data={ordersDetails[0]?.przedmiot_skladowania} />
        </QuantumContainer>
      </WhitePage>
    </OrderContainer>
  );
};
const OrderContainer = styled.div`
  display: flex;
  flex-direction: column;
  //TODO
  margin-left: 0;
  padding: 0 10px;

  @media ${theme.device.laptop} {
    margin-left: 310px;
    padding-right: 50px;
  }
`;
const ViewNavigation = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  @media (max-width: 340px) {
    flex-direction: column;
  }
`;
const SummaryTableContainer = styled.div`
  display: flex;
`;
const ServicesContainer = styled.div`
  //margin:30px 0px;
  @media (max-width: 500px) {
    width: 100%;
    display: flex;
    flex-direction: column;
  }
`;
const QuantumContainer = styled.div``;
const SectionTitle = styled.div`
  margin-bottom: 14px;
  font-family: ${theme.fonts.interRegular} !important;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: black;
  font-family: "Inter";
  color: ${theme.colors.black_primaryText};
  @media (max-width: 500px) {
    margin-top: 16px;
  }
`;
const WhitePage = styled.div`
  background: ${theme.colors.white};
  border-radius: 8px;
  padding: 32px;
  margin-bottom: 20px;
  @media (max-width: 500px) {
    padding: 0px 10px;
    padding-bottom: 16px;
  }
`;
const Redirect = styled.div`
  display: flex;
  align-items: center;
  padding-bottom: 24px;
`;
const TableRow = styled.div`
  height: 163px;
  width: 100 %;
  display: flex;
  //margin-left: ${window.screen.width > 1024 ? "350px" : "0"};
  //padding-right: ${window.screen.width > 1024 ? "50px" : "0"};
`;
